import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ContainerState } from './types';

// Define the initial state using the API structure
export const initialState: ContainerState = {
    mockApiFlag: false,
    mysqlFlag: true,
    excludeMysqlParams: [],
    metrics: { data: [], loading: false, error: null },
    timeperiod: { data: [], loading: false, error: null },
    dataGridData: { data: [], loading: false, error: null },
    nurturingHistory: { data: [], loading: false, error: null },
    taskHtml: { data: {}, loading: false, error: null },
    exportData: { data: {}, loading: false, error: null },
};

// Create the slice using Redux Toolkit's createSlice
const salesDemoSlice = createSlice({
    name: 'salesDemoState', // Unique name for the slice (key)
    initialState,
    reducers: {
        // reducer to toggle mock data usage
        toggleUseMockData(state, action: PayloadAction<boolean>) {
            state.mockApiFlag = action.payload;
        },
        toggleUseMysql(state, action: PayloadAction<boolean>) {
            state.mysqlFlag = action.payload;
        },
        // Add or remove API types from the excludeMysqlParams list
        updateExcludeMysqlParams(state, action: PayloadAction<{ apiType: string, exclude: boolean; }>) {
            const { apiType, exclude } = action.payload;

            if (exclude && !state.excludeMysqlParams.includes(apiType)) {
                // Add to the list of excluded APIs
                state.excludeMysqlParams.push(apiType);
            } else if (!exclude && state.excludeMysqlParams.includes(apiType)) {
                // Remove from the list of excluded APIs
                state.excludeMysqlParams = state.excludeMysqlParams.filter(type => type !== apiType);
            }
        },
        requestMetrics(state, action: PayloadAction<any>) {
            state.metrics.loading = true;
            state.metrics.error = null;
        },
        requestMetricsSuccess(state, action: PayloadAction<any>) {
            state.metrics.data = action.payload;
            state.metrics.loading = false;
        },
        requestMetricsError(state, action: PayloadAction<string>) {
            state.metrics.error = action.payload;
            state.metrics.loading = false;
        },
        requestTimeperiod(state, action: PayloadAction<any>) {
            state.timeperiod.loading = true;
            state.timeperiod.error = null;
        },
        requestTimeperiodSuccess(state, action: PayloadAction<any>) {
            state.timeperiod.data = action.payload;
            state.timeperiod.loading = false;
        },
        requestTimeperiodError(state, action: PayloadAction<string>) {
            state.timeperiod.error = action.payload;
            state.timeperiod.loading = false;
        },
        requestDataGridData(state, action: PayloadAction<any>) {
            state.dataGridData.loading = true;
            state.dataGridData.error = null;
        },
        requestDataGridDataSuccess(state, action: PayloadAction<any>) {
            state.dataGridData.data = action.payload;
            state.dataGridData.loading = false;
        },
        requestDataGridDataError(state, action: PayloadAction<string>) {
            state.dataGridData.error = action.payload;
            state.dataGridData.loading = false;
        },
        requestNurturingHistory(state, action: PayloadAction<any>) {
            state.nurturingHistory.loading = true;
            state.nurturingHistory.error = null;
        },
        requestNurturingHistorySuccess(state, action: PayloadAction<any>) {
            state.nurturingHistory.data = action.payload;
            state.nurturingHistory.loading = false;
        },
        requestNurturingHistoryError(state, action: PayloadAction<string>) {
            state.nurturingHistory.error = action.payload;
            state.nurturingHistory.loading = false;
        },
        requestTaskHtml(state, action: PayloadAction<any>) {
            state.taskHtml.loading = true;
            state.taskHtml.error = null;
        },
        requestTaskHtmlSuccess(state, action: PayloadAction<any>) {
            state.taskHtml.data = {
                ...state.taskHtml.data,
                ...action.payload
            };
            state.taskHtml.loading = false;
        },
        requestTaskHtmlError(state, action: PayloadAction<any>) {
            state.taskHtml.error = action.payload;
            state.taskHtml.loading = false;
        },
        requestExportData(state, action: PayloadAction<any>) {
            state.exportData.loading = true;
            state.exportData.error = null;
        },
        requestExportDataSuccess(state, action: PayloadAction<any>) {
            state.exportData.data = action.payload;
            state.exportData.loading = false;
        },
        requestExportDataError(state, action: PayloadAction<any>) {
            state.exportData.error = action.payload;
            state.exportData.loading = false;
        },
        clearDatagridData(state,) {
            state.dataGridData.data = [];
        },
        clearTaskHtml(state,) {
            state.taskHtml.data = {};
        },
        clearNurturingHistory(state,) {
            state.nurturingHistory.data = [];
        },
    },
});

export const {
    actions: salesDemoActions,
    reducer,
    name: sliceKey,
} = salesDemoSlice;
